import React, { useCallback, useEffect } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Stuff from './Stuff';
const PAINTINGS = [
    {
        src: 'https://www.sagishutrit.nl/images/acid-bloom/SagiShutrit_AcidBloom_30x30_ink&GouacheOnCarton_2023.jpg',
        title: 'untitled',
        year: '2024',
        medium: 'watercolor on carton',
        format: '40 x 40 cm'
      },
 {
        src: "https://sagishutrit.viewingrooms.nl/assets/shuarma_in_the_mall.jpg",
        title: 'Yes, of course there is a shawarma place in the new mall',
        year: '2025',
        medium: 'Oil on cotton',
        dimensions: '160 x 130cm',
      
  },
  {
    src: "https://www.sagishutrit.nl/images/helena/carousel-plentage.png",
    title: 'untitled',
    year: '2025',
    medium: 'Oil on canvas',
    dimensions: '',
  },
  {
  src: "https://www.sagishutrit.nl/images/helena/vasoline_2025_40_50.png",
  title: 'Vasoline',
  year: '2025',
  medium: 'Oil on canvas',
  dimensions: '40x50',
  },
  {
    src: "https://www.sagishutrit.nl/images/helena/closets_2026may_oil_on_canvas_30_40.jpg",
    title: 'untitled',
    year: '2026',
    medium: 'Oil on canvas',
    dimensions: '40x50',
  }
];

const OPTIONS = { 
  loop: true,         
  align: 'center',    
  skipSnaps: false,   
  duration: 30,       
};

export function PaintingCarousel() {
  // Grab the v9 emblaApi instance
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);

  // FIXED FOR V9: Changed from scrollPrev/Next to goToPrev/Next
  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.goToPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.goToNext()
  }, [emblaApi])
  
  useEffect(() => {
    setInterval(() => {
      scrollNext()
    },3000)
  })

  return (
    <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', paddingTop: '20px', paddingBottom: '20px', display: 'flex', position: 'relative', border: '0px solid green' }}>
      {/* <div className="inspired-by-tank" style={{ border:'1px solid pink', pading: '0', margin:'0 auto',display:'flex', flexDirection:'column'}}>
      <h5>Inspired by </h5> */}
      <Stuff />
      {/* </div> */}
      {/* 1. Embla Viewport Box */}
      <div className="embla" ref={emblaRef} style={{ overflow: 'hidden',width: '100%',maxWidth: '900px',margin: '0 auto' }}>
        
        {/* 2. Embla Container */}
        <div className="embla__container" style={{ width:'100%', border: '0px solid purple' }}>
          {PAINTINGS.map((painting, index) => (
            <div 
              className="embla__slide" 
              key={index} 
              style={{
               // flex: '50% 0 100%', // Makes each slide container occupy the full viewport space
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', // Centers the hardcoded image box horizontally
                justifyContent: 'center',
                padding: '0 10px',
                boxSizing: 'border-box',
                border: '0px solid orange' 
              }}
            >
              {/* 3. Hardcoded Image Frame Box — Ensures no image data is hidden */}
              <div style={{ 
                width: '100%', 
                maxWidth: '800px',  // Hardcoded constraint box for the painting canvas
                height: '500px',    // Fixed height frame
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // background: '#f4f4f4', // Subtle background fallback for varying aspect ratios
                borderRadius: '4px',
                overflow: 'hidden'
              }}>
                <img 
                  src={painting.src} 
                  alt={painting.title} 
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: '100%', 
                    objectFit: 'contain' // Ensures the complete original image fits entirely in view without clipping
                  }} 
                />
              </div>

              {/* Text Meta Info */}
              <div className='painting-info' style={{ marginTop: '15px', textAlign: 'center' }}>
                <p  className='carousel-item-header'>{painting.title}, {painting.year}</p>
                <p className='carousel-item-header'><em>{painting.medium}</em> - {painting.dimensions}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 4. Controls */}


    </div>
  )
}

export default PaintingCarousel;